import { render, staticRenderFns } from "./history-item.vue?vue&type=template&id=3bbc9a26&scoped=true&"
import script from "./history-item.component.ts?vue&type=script&lang=ts&"
export * from "./history-item.component.ts?vue&type=script&lang=ts&"
import style0 from "./history-item.vue?vue&type=style&index=0&id=3bbc9a26&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bbc9a26",
  null
  
)

export default component.exports